const INTUIT_APIKEY = window.__shellInternal?.appExperience.appApiKey;

export const APP_FABRIC_CONFIG = {
  proxyBaseUrl: 'https://mc-appfabricproxy-e2e.api.intuit.com',
  proxyDefaultOptions: {
    mode: 'cors',
    credentials: 'include',
    redirect: 'follow',
  },

  // Dynamic values needed for request headers for Proxy
  intuit_apikey: INTUIT_APIKEY,
  intuit_userid: window.__shellInternal?.applicationContext.userAuthInfo.authId,

  // Static values for now
  // intuit_token: '', // Get qbn.ptc.ticket cookie value in devportal-e2e.intuit.com

  // This will eventually be mapped on Interposer based on the intuit_userid
  mc_userid: '', // Please use your Mailchimp E2E user_id here instead of test version
  csrf_token: '',
  authorization_header_value: `Intuit_APIKey intuit_apikey=${INTUIT_APIKEY}, intuit_apikey_version=1.0`,
  incoming_host: 'e2e.admin.mailchimp.com',
} as const;
